<!--
Author: TangChen
Date: 2018-11-26
Desc: 用户持有银行卡信息操作组件，增卡 由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-add-bank bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/bank' }">我的银行卡</el-breadcrumb-item>
                <el-breadcrumb-item>签约</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <bank-operation :cate="sceneEnum.sign" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import bankOperation from "@/components/form/bankOperation";
import { sceneEnum } from "@/util/util_jfit";
export default {
    name: "AddBank",
    components: {
        bankOperation
    },
    mixins: [mixin],
    data() {
        return {};
    },
    computed: {
        sceneEnum() {
            return sceneEnum;
        }
    }
};
</script>
